const CurrencyTemplate = ({
  prefixCurrencySymbol,
  fontSetClass,
  inlineBlockSetClass,
  fontWeightSetClass,
  discountPriceCurrencySymbol,
  price,
  isDiscountPrice,
}) => {
  const inlineBlockSetClassNode = isDiscountPrice ? inlineBlockSetClass : '';
  return (
    <span
      className={`${fontSetClass || ''} ${fontWeightSetClass || ''} ${
        inlineBlockSetClass || ''
      }`}
    >
      {prefixCurrencySymbol && (
        <span className={inlineBlockSetClassNode}>
          {discountPriceCurrencySymbol}
        </span>
      )}
      <span>{price}</span>
      {!prefixCurrencySymbol && <span>{discountPriceCurrencySymbol}</span>}
    </span>
  );
};

export default CurrencyTemplate;
